import * as tslib_1 from "tslib";
var account = {
    namespaced: true,
    state: {},
    actions: {
        isTenantAvailable: function (state, payload) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var rep;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, abp.ajax.post('/api/services/app/Account/IsTenantAvailable', payload.data)];
                        case 1:
                            rep = _a.sent();
                            return [2 /*return*/, rep.data.result];
                    }
                });
            });
        }
    }
};
export default account;
